import { Injectable } from "@angular/core";
import {
  Http,
  Response,
  Headers,
  Request,
  RequestOptions,
} from "@angular/http";
import { throwError as observableThrowError, Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { map, catchError } from "rxjs/operators";
import { AuthHeaderService } from "../views/authheader.service";

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {
  getloadsurl: string;
  getinvoiceurl: string;
  createfactorinvoiceurl: string;
  trumpurl: string
  getfactoringurl: string
  downloadFactorFiles:string
  constructor(private http: Http, private _headerService: AuthHeaderService) {
    this.getloadsurl = environment.getloadsurl;
    this.getinvoiceurl = environment.getinvoiceurl;
    this.createfactorinvoiceurl = environment.createfactorinvoiceurl
    this.trumpurl = environment.trumpurl,
      this.getfactoringurl = environment.getfactoringurl
      this.downloadFactorFiles = environment.downloadFactorFiles
  }

  createInvoice(load, salesOrderNo="") {
    // console.log(JSON.stringify(load));
    let urlWithParam = this.getinvoiceurl;

    // Append salesOrderNo to the URL as a query parameter if it is provided
    if (salesOrderNo) {
      urlWithParam += `?salesOrderNo=${encodeURIComponent(salesOrderNo)}`;
    }
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(urlWithParam, load, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  createFactorInvoice(load) {
    // console.log(JSON.stringify(load));
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(this.createfactorinvoiceurl, load, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  sendToTrump(load) {
    // console.log(JSON.stringify(load));
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(this.trumpurl, load, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  DownloadFactorFiles(load) {
    // console.log(JSON.stringify(load));
    let headers=this._headerService.getHeader()
    headers['responseType']= 'blob'
    let options = new RequestOptions({
      headers: headers,
    });
    return this.http.post(this.downloadFactorFiles, load, options).pipe(
      map((response:any) => {
        const data = response.json().buffer.data;
        const blob = new Blob([new Uint8Array(data)], { type: 'application/octet-stream' });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.download = 'FactorFiles.zip';
        document.body.appendChild(link);
        link.click();

        // Clean up
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        }),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getLoadsForInvoice(searchOptions) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    let url = this.getinvoiceurl + "/loadsforinvoice";
    let isSearchOptionsEmpty = Object.values(searchOptions).every(x => (x === null || x === ''));
    if (!isSearchOptionsEmpty) {
      url = url + '?';
      if (searchOptions["customerId"] != "" && searchOptions["customerId"] != null) {
        url = url + "customerId=" + searchOptions["customerId"] + '&';
      }
      if (searchOptions["loadNumber"] != "" && searchOptions["loadNumber"] != null) {
        url = url + "loadNumber=" + searchOptions["loadNumber"] + '&';
      }
      if (searchOptions["dispatcher"] != "" && searchOptions["dispatcher"] != null) {
        url = url + "dispatcher=" + searchOptions["dispatcher"] + '&';
      }
      if (searchOptions["invoiceStatus"] != "" && searchOptions["invoiceStatus"] != null) {
        url = url + "loadStatus=" + searchOptions["invoiceStatus"] + '&';
      }
      if (searchOptions["fromDate"] != "" && searchOptions["fromDate"] != null) {
        url = url + "fromDate=" + searchOptions["fromDate"] + '&';
      }
      if (searchOptions["toDate"] != "" && searchOptions["toDate"] != null) {
        url = url + "toDate=" + searchOptions["toDate"] + '&';
      }


    }
    return this.http.get(url, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }


  getInvoicesforLoad() {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.getinvoiceurl, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  getInvoiceLineItemsforLoad() {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    var url = this.getinvoiceurl + "/lineitems"
    return this.http.get(url, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  getInvoiceList() {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.getinvoiceurl + "/invoicelist", options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getBCpostedInvoiceList(searchOptions = {}) {
    console.log(searchOptions);
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    let url =this.getinvoiceurl + "/bcpostedinvoices";
    let isSearchOptionsEmpty = Object.values(searchOptions).every(x => (x === null || x === ''));
    if (!isSearchOptionsEmpty) {
      url = url + '?';
      if (searchOptions["customerId"] != "" && searchOptions["customerId"] != null) {
        url = url + "customerId=" + searchOptions["customerId"] + '&';
      }
      if (searchOptions["cancelled"] == false) {
        url = url + "cancelled=" + searchOptions["cancelled"] + '&';
      }
      if (searchOptions["cancelled"] == true) {
        url = url + "cancelled=" + searchOptions["cancelled"] + '&';
      }
      if (searchOptions["invoiceId"]) {
        url = url + "invoiceId=" + searchOptions["invoiceId"] + '&';
      }
      if (searchOptions["fromDate"]) {
        url = url + "fromDate=" + searchOptions["fromDate"] + '&';
      }
      if (searchOptions["toDate"]) {
        url = url + "toDate=" + searchOptions["toDate"] + '&';
      }
    }
    console.log(url);
    return this.http.get(url, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  
  getInvoiceReportList(searchOptions) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    let url = this.getinvoiceurl + "/invoicelist";
    let isSearchOptionsEmpty = Object.values(searchOptions).every(x => (x === null || x === ''));
    if (!isSearchOptionsEmpty) {
      url = url + '?';
      if (searchOptions["customerId"] != "" && searchOptions["customerId"] != null) {
        url = url + "customerId=" + searchOptions["customerId"] + '&';
      }
      if (searchOptions["loadNumber"] != "" && searchOptions["loadNumber"] != null) {
        url = url + "loadNumber=" + searchOptions["loadNumber"] + '&';
      }
      if (searchOptions["dispatcher"] != "" && searchOptions["dispatcher"] != null) {
        url = url + "dispatcher=" + searchOptions["dispatcher"] + '&';
      }
      if (searchOptions["fromDate"] != "" && searchOptions["fromDate"] != null) {
        url = url + "fromDate=" + searchOptions["fromDate"] + '&';
      }
      if (searchOptions["toDate"] != "" && searchOptions["toDate"] != null) {
        url = url + "toDate=" + searchOptions["toDate"] + '&';
      }
      if (searchOptions["type"] != "" && searchOptions["type"] != null) {
        url = url + "type=" + searchOptions["type"] + '&';
      }
      if (searchOptions["invoiceNo"] != "" && searchOptions["invoiceNo"] != null) {
        url = url + "invoiceId=" + searchOptions["invoiceNo"] + '&';
      }


    }
    return this.http.get(url, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  getFactoringInvoiceList(searchOptions) {
    var url = this.getfactoringurl;
    let isSearchOptionsEmpty = Object.values(searchOptions).every(x => (x === null || x === ''));
    if (!isSearchOptionsEmpty) {
      url = url + '?';
      if (searchOptions["customerId"] != "" && searchOptions["customerId"] != null) {
        url = url + "customerId=" + searchOptions["customerId"] + '&';
      }
      if (searchOptions["loadNumber"] != "" && searchOptions["loadNumber"] != null) {
        url = url + "loadNumber=" + searchOptions["loadNumber"] + '&';
      }
      if (searchOptions["dispatcher"] != "" && searchOptions["dispatcher"] != null) {
        url = url + "dispatcher=" + searchOptions["dispatcher"] + '&';
      }
      if (searchOptions["invoiceStatus"] != "" && searchOptions["invoiceStatus"] != null) {
        url = url + "loadStatus=" + searchOptions["invoiceStatus"] + '&';
      }
      if (searchOptions["factor"] != "" && searchOptions["factor"] != null) {
        url = url + "factor=" + searchOptions["factor"] + '&';
      }
      if (searchOptions["branchNo"] != "" && searchOptions["branchNo"] != null) {
        url = url + "factorBatchNo=" + searchOptions["branchNo"] + '&';
      }
      if (searchOptions["fromDate"] != "" && searchOptions["fromDate"] != null) {
        url = url + "fromDate=" + searchOptions["fromDate"] + '&';
      }
      if (searchOptions["toDate"] != "" && searchOptions["toDate"] != null) {
        url = url + "toDate=" + searchOptions["toDate"] + '&';
      }
    }
      let options = new RequestOptions({
        headers: this._headerService.getHeader(),
      });
      return this.http.get(url, options).pipe(
        map((response) => response.json()),
        catchError((error: Response) => {
          return observableThrowError(error);
        })
      );
    
  }

  cancelInvoice(load) {
    // console.log(JSON.stringify(load));
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(this.getinvoiceurl + "/cancel", load, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }



  getFactorInvoiceList(searchOptions, type) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    let url = this.getinvoiceurl + "/" + type;
    let isSearchOptionsEmpty = Object.values(searchOptions).every(x => (x === null || x === ''));
    if (!isSearchOptionsEmpty) {
      url = url + '?';
      if (searchOptions["customerId"] != "" && searchOptions["customerId"] != null) {
        url = url + "customerId=" + searchOptions["customerId"] + '&';
      }
      if (searchOptions["loadNumber"] != "" && searchOptions["loadNumber"] != null) {
        url = url + "loadNumber=" + searchOptions["loadNumber"] + '&';
      }
      if (searchOptions["dispatcher"] != "" && searchOptions["dispatcher"] != null) {
        url = url + "dispatcher=" + searchOptions["dispatcher"] + '&';
      }
      if (searchOptions["invoiceStatus"] != "" && searchOptions["invoiceStatus"] != null) {
        url = url + "loadStatus=" + searchOptions["invoiceStatus"] + '&';
      }
      if (searchOptions["fromDate"] != "" && searchOptions["fromDate"] != null) {
        url = url + "fromDate=" + searchOptions["fromDate"] + '&';
      }
      if (searchOptions["toDate"] != "" && searchOptions["toDate"] != null) {
        url = url + "toDate=" + searchOptions["toDate"] + '&';
      }
      if (searchOptions["factor"] != "" && searchOptions["factor"] != null) {
        url = url + "factor=" + searchOptions["factor"] + '&';
      }


    }
    return this.http.get(url, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getBCSalesOrderList() {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.getinvoiceurl + "/salesorder", options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getBCSalesInvoiceList() {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.getinvoiceurl + "/salesinvoices", options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getBCInvoiceList(searchOptions={}) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    let url =this.getinvoiceurl+ "/bcinvoices";
    let isSearchOptionsEmpty = Object.values(searchOptions).every(x => (x === null || x === ''));
    if (!isSearchOptionsEmpty) {
      url = url + '?';
      if (searchOptions["customerId"] != "" && searchOptions["customerId"] != null) {
        url = url + "customerId=" + searchOptions["customerId"] + '&';
      }
      if (searchOptions["loadNumber"] != "" && searchOptions["loadNumber"] != null) {
        url = url + "loadNumber=" + searchOptions["loadNumber"] + '&';
      }
      if (searchOptions["invoiceStatus"] != "" && searchOptions["invoiceStatus"] != null) {
        url = url + "invoiceStatus=" + searchOptions["invoiceStatus"] + '&';
      }
      if (searchOptions["fromDate"] != "" && searchOptions["fromDate"] != null) {
        url = url + "fromDate=" + searchOptions["fromDate"] + '&';
      }
      if (searchOptions["toDate"] != "" && searchOptions["toDate"] != null) {
        url = url + "toDate=" + searchOptions["toDate"] + '&';
      }


    }
    return this.http.get(url, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  
  updateBCSalesOrder(payload) {
    // console.log(JSON.stringify(load));
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.put(this.getinvoiceurl + "/salesorder", payload, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  cancelBCSalesOrder(payload) {
    // console.log(JSON.stringify(load));
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(this.getinvoiceurl + "/bccancel", payload, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
}
